import { createComponent, customMap } from 'redux-form-antd';
import { Select, DatePicker, Checkbox } from 'antd';
import moment from 'moment';

const { RangePicker } = DatePicker;
const selectMap = customMap(
  (mapProps, { input: { onChange, value }, multiple, options, placeholder }) => {
    if (!placeholder && (options && options.length > 0)) {
      value = value || (multiple ? [options[0].value] : options[0].value);
    }
    if (placeholder) {
      value = value === '' ? undefined : value;
    }
    return { ...mapProps, dropdownMatchSelectWidth: true, value, style: { minWidth: 200 } };
  }
);

const datePickerMap = customMap((mapProps, { input: { onChange, value }, dateFormat }) => {
  if (Array.isArray(value)) {
    value = value.map(v => moment(v, dateFormat));
  }

  return {
    ...mapProps,
    onChange,
    value,
    format: dateFormat,
  };
});

const checkMap = customMap((mapProps, { input: { value } }) => ({
  ...mapProps,
  checked: value,
}));

export const SelectField = createComponent(Select, selectMap);
export const CheckboxField = createComponent(Checkbox, checkMap);
export const CombinedRangePicker = createComponent(RangePicker, datePickerMap);
